<div class="subBlockContent">
  <child-header [title]="title" (closeEvent)="close()"></child-header>
  <div #ParentWrapper class="child-body">
    <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->
      
      <div class="content content-light color-dark" *ngIf="orderConfirmationInfo">
        <div class="two-column-area">
          <p class="confirm-text">Your order has been placed.</p>
          <p
            *ngIf="orderConfirmationInfo.orderNumber === subscriptionOrderNo || orderConfirmationInfo.containsSubscriptionItem">
            Your subscriptions have been successfully placed in our system and will be activated after approval from the
            vendor. <br />
            This will take a few minutes, you can manage the subscription by clicking Manage button.
          </p>
          <p *ngIf="orderConfirmationInfo.orderNumber !== subscriptionOrderNo">
            An order confirmation has been emailed to you and you should receive it within the next 5 minutes.
            Alternatively view the confirmation below.
          </p>

          <p class="additional-order-info">
            <ng-container *ngIf="orderConfirmationInfo.orderNumber !== subscriptionOrderNo">
              <span style="font-weight:600">ORDER NUMBER:&nbsp;</span><span>{{orderConfirmationInfo.orderNumber}}</span>
              <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            </ng-container>
            <span style="font-weight:600">PO/Client
              Reference:&nbsp;</span><span>{{orderConfirmationInfo.poReference}}</span>
          </p>

          <div class="checkout-order-header section-container row">
            <div class="col-md-4" *ngIf="deliverySummary">
              <app-delivery-summary [deliverySummary]="deliverySummary" [enableEdit]="false"></app-delivery-summary>
            </div>
            <div class="col-md-4" *ngIf="paymentSummary">
              <app-payment-summary [paymentSummary]="paymentSummary" [enableEdit]="false"></app-payment-summary>
            </div>
            <div class="col-md-4" *ngIf="partshipSummary">
              <app-partship-summary [partshipSummary]="partshipSummary" [enableEdit]="false"></app-partship-summary>
            </div>
          </div>
          <div class="mTable" *ngIf="cartDetails">
            <app-item-summary [cartDetails]="cartDetails" [checkoutSummary]="orderConfirmationInfo">
            </app-item-summary>
          </div>
          <div class="button-center">
            <a class="button button-red button-large button-center-left" style="padding-top: 3px;" target="_blank"
              href="https://{{domainName}}/api/ExportExcel/PrintToPDF?completedCartId={{cartId}}">Print</a>
            <a [routerLink]="['/home']" class="button button-red button-large button-center-right" style="padding-top: 3px;">
              Continue Shopping
            </a>

            <a *ngIf="orderConfirmationInfo.tenantId && orderConfirmationInfo.tenantId.startsWith('AD')"
              class="global-button" (click)="goToManageSubscription()">
              Manage
            </a>
            <a *ngIf="orderConfirmationInfo.tenantId && !orderConfirmationInfo.tenantId.startsWith('AD')"
              class="global-button" (click)="goToManageSubscription()">
              Manage
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <loading-screen *ngIf="!loadContent" [scrollAfterLoading]="true" [showBlurTable]="false" (currentLoadingStatus)="onLoading($event)"></loading-screen>
</div>
